import { Outlet, useParams } from "react-router-dom";

import { useTrial } from "@/routes/trial/queries";

export default function TrialLayout() {
    const { trialId } = useParams<{ trialId: string }>();

    const { trial, loading, error, refetch } = useTrial(trialId);

    if (!trialId) {
        return null;
    }

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!trial) {
        return <p>Trial not found</p>;
    }

    return <Outlet context={{ trial, refetch }} />;
}
